export const SUBSCRIPTION_INIT = 'SUBSCRIPTION_INIT'
export const SUBSCRIPTION_SUCCEDED = 'SUBSCRIPTION_SUCCEDED'
export const SUBSCRIPTION_FAILED = 'SUBSCRIPTION_FAILED'

export const ENDPOINT_SUBSCRIPTION = "/api/packs/subscribe"
